module.exports = __webpack_public_path__ + "static/media/blue-bg.803efc2d.png";